import { ArrowDown } from '@ankr.com/ui';
import { CircularProgress, Typography } from '@mui/material';
import { t } from '@ankr.com/common';

import { LoadableButton } from 'uiKit/LoadableButton';

import { BalanceStatusIcon } from './components/BalanceStatusIcon';
import { useBalanceButtonStyles } from './useBalanceButtonStyles';

export interface IBalanceButtonProps {
  isMenuOpen: boolean;
  balance: number;
  hasStatusTransition: boolean;
  isLoading: boolean;
  isLoggedIn: boolean;
  handleClose: () => void;
  handleOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const valueBalanceKey = 'header.balance-button.value';
const creditBalanceKey = 'header.balance-button.credits';

export const BalanceButton = ({
  balance,
  handleClose,
  handleOpen,
  hasStatusTransition,
  isLoading,
  isLoggedIn,
  isMenuOpen,
}: IBalanceButtonProps) => {
  const { classes } = useBalanceButtonStyles({
    isMenuOpen,
  });

  const hasEndIcon = !isLoading && hasStatusTransition;

  if (!isLoggedIn) return null;

  const balanceKey = creditBalanceKey;

  return (
    <LoadableButton
      className={classes.root}
      endIcon={hasEndIcon && <CircularProgress size={20} />}
      loading={isLoading}
      onClick={isMenuOpen ? handleClose : handleOpen}
      variant="text"
    >
      <div className={classes.content}>
        <BalanceStatusIcon />
        <Typography variant="button3" className={classes.balance}>
          <span className={classes.balanceValue}>
            {t(valueBalanceKey, { balance })}
          </span>
          {t(balanceKey)}
        </Typography>
        <ArrowDown className={classes.selectIcon} />
      </div>
    </LoadableButton>
  );
};
